import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import ReactGA from "react-ga4";

import {
  arrayToString,
  getSearchApiDateFormat,
} from "../../../../utility/common-methods";
import {
  FilterIcon,
  NoFeedIcon,
  MenuIcon,
  DownLoadSuccess,
} from "../../../Icons/icons.component";
import TopicWiseNewsContainer from "./TopicWiseNewsContainer";
import {
  CONSTANTS,
  COOKIE,
  MAX_FEEDS_LIMIT,
  VERTICALS,
  FEEDS_API_RETRY_LIMIT,
} from "../../../../constants/app-constant";
import {
  fetchPrintFeeds,
  fetchNewPrintFeedsByEntity,
} from "../../../../actions/print-feeds-action";
import Loader from "../../../Shared/Loader";
import Filters from "../../Filters/Filters";
import DateRangeFilter from "../../Filters/DateRangeFilter";
import DownloadFeeds from "../DownloadFeeds";
import ArticleTags from "../ArticleTags";
import { fetchPressRelease } from "../../../../actions/filters-actions";
import ConceptLogo from "../../../../assets/images/conceptbiu-logo.png";
import "../../Analysis/print.sass";
import { httpGet } from "../../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import ShareArticle from "../../../Shared/ShareArticle";
import { getCookie, setCookie } from "../../../../utility/cookieProvider";
import styles from "../../Download.module.css";
import DownloadPopup from "../../DownloadPopup";
import GifLoader from "../../../Shared/LoaderGif";
import {GACODE} from "../../../../constants/app-constant";

const { V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE_OLD } = VERTICALS;
const { EMPTY_OBJECT, EMPTY_ARRAY, EMPTY_STRING } = CONSTANTS;
const initDate = getSearchApiDateFormat();

export default function PrintAndOnlineNews() {
  ReactGA.initialize(GACODE);
  const listContainerRef = useRef(null);

  const dispatch = useDispatch();
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || EMPTY_OBJECT;
  const clientLanguage =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.clientLanguage
    ) || EMPTY_OBJECT;
  const [feedObjList, setFeedObjList] = useState([]);
  const [startRange, setStartRange] = useState(initDate);
  const [endRange, setEndRange] = useState(initDate);
  const [filters, setFilters] = useState({
    edition: [],
    publication_type: null,
    publication: null,
    tonality: null,
    zone: null,
    entity: null,
    category: null,
    client: selectedClientId,
    media_type: selectedClient.is_online_access === "1" && selectedClient.is_print_access === "1"?[V_PRINT, V_ONLINE]:(selectedClient.is_online_access === "1"?[V_ONLINE]:(selectedClient.is_print_access === "1"?[V_PRINT]:[V_PRINT, V_ONLINE])),
    headline: null,
    keywords: null,
    typedPublication: null,
    typedReporter: null,
    reporter: [],
    source_type: null,
    press_release: null,
    favourite: null,
    languages:clientLanguage?.map(lData => lData.id),
    state : null
  });
  const [offset, setOffset] = useState(0);
  const [activeKey, setActiveKey] = useState(-1);
  const [showFilter, toggleFilter] = useState(false);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedsGroup, setSelectedFeedsGroup] = useState([]);
  const [isFeedInit, setIsFeedInit] = useState(false);
  const [updatedBulkSentiment, setUpdatedBulkSentiment] = useState("");
  const [updatedBulkFavourite, setUpdatedBulkFavourite] = useState("");
  const [updatedBulkTheme, setUpdatedBulkTheme] = useState(undefined);
  const [customParamsData, setCustomParamsData] = useState({});
  const [appliedFilters, setApplyFilters] = useState(false);
  const [newEntityList, setNewEntityList] = useState([]);
  const [selectAll, setSelectAll] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const isSocialDownloading = getCookie(COOKIE.IS_SOCIAL_DOWNLOADING);
  const isPrintDownloading = getCookie(COOKIE.IS_PRINT_DOWNLOADING);
  const isBlogDownloading = getCookie(COOKIE.IS_BLOG_DOWNLOADING);
  const DownloadSuccess = getCookie(COOKIE.DOWNLOAD_SUCCESS);
  const [popup, setPopup] = useState(false);
  const [showList, setShowList] = useState(true);
  const [totalArticleCount, setTotalArticleCount] = useState(0);
  const [responseEntityWithCount, setResponseEntityWithCount] = useState(null);

  const entityList =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.entityDetails &&
        state.entityAndKeyWordsReducer.entityDetails.entityList
    ) || EMPTY_ARRAY;

  const entityLoader =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.entityDetails
    ) || false;

  const printNewsFeeds =
    useSelector(
      (state) =>
        state.printFeedsReducer && state.printFeedsReducer.printNewsFeeds
    ) || EMPTY_OBJECT;

  let selectedClientId = selectedClient && selectedClient.id;
  const hasEntities = entityList && entityList.length;
  const shouldFetchFeedsByDefault = selectedClientId;

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClientId != undefined && selectedClientId != '' && selectedClientId != null){
    ReactGA.set({ userId: selectedClientId+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClientId+".0."+concept_uid });
  }
  
  let locationHrefNew = window.location.href;
  if(selectedClientId != undefined && selectedClientId != '' && selectedClientId != null){
    ReactGA.event({
      category: "Print & Online",
      action: "Print & Online - "+selectedClientId+".0."+concept_uid,
      label: locationHrefNew, // optional
      //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
    }); 
  }

  useEffect(() => {
    initEntityFilter();
    if (entityList && entityList.length) {
      setNewEntityList(entityList);
    }
  }, [entityList]);

  useEffect(() => {
    setFilters((prevState) => {
      return { ...prevState, client: selectedClientId };
    });
    dispatch(fetchPressRelease(selectedClientId));
  }, [selectedClientId]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("articleIdList");
    };
  }, []);
  useEffect(() => {
    if (DownloadSuccess === "true") {
      setPopup(DownloadSuccess === "true");
    }
    setTimeout(() => {
      setCookie({
        key: COOKIE.DOWNLOAD_SUCCESS,
        value: false,
      });
      setPopup(false);
    }, 5000);
  }, [DownloadSuccess]);

  useEffect(() => {
    // printNewsFeeds &&
    //   !Object.keys(printNewsFeeds.data).length &&
    //   selectedClientId &&
    // callFeedsApi(undefined, false, undefined, true);
  }, [shouldFetchFeedsByDefault]);

  useEffect(() => {
    // isFeedInit &&
    // selectedClientId && callFeedsApi(undefined, false, undefined, false);
  }, [startRange, endRange]);

  useEffect(() => {
    if (updatedBulkSentiment || updatedBulkTheme) {
      setSelectedFeeds([]);
      setSelectedFeedsGroup([]);
    }
  }, [updatedBulkSentiment, updatedBulkTheme]);

  useEffect(() => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  }, [updatedBulkFavourite]);

  useEffect(() => {
    setResponseEntityWithCount(null);
    setTotalArticleCount(0);
    newEntityList.length && getFeedsByEntityList();
  }, [newEntityList, customParamsData, startRange, endRange]);

  useEffect(() => {
    if (responseEntityWithCount !== null) updateTotalArticleElement();
  }, [responseEntityWithCount]);

  const initEntityFilter = () => {
    if (selectAll) {
      setFilters((prevState) => {
        return { ...prevState, entity: entityList.map((e) => e.id) };
      });
    } else {
      setFilters((prevState) => {
        return { ...prevState, entity: [] };
      });
    }
  };

  const getCorrectedReporter = () => {
    const { reporter } = filters;
    if (Array.isArray(reporter)) {
      return arrayToString(reporter.map((e) => e && e.text));
    }
    if (reporter && reporter.text) {
      return reporter.text;
    } else return "";
  };

  const getCorrectPublication = () => {
    const { publication } = filters;
    if (!publication) {
      return [];
    }
    if (Array.isArray(publication) && publication.length) {
      return publication.map((p) => p.id);
    }
    return publication.id ? [publication.id] : [];
  };

  const getCorrectVertical = () => {
    const { media_type } = filters;
    const isPrintSelected = media_type.indexOf(V_PRINT) !== -1;
    const isOnlineSelected = media_type.indexOf(V_ONLINE) !== -1;
    const isBothSelected = (isOnlineSelected && isPrintSelected) || (media_type.indexOf(V_PRINT_AND_ONLINE_OLD) !== -1);
    if (isBothSelected) {
      return V_PRINT_AND_ONLINE_OLD;
    }
    if (isOnlineSelected) {
      return V_ONLINE;
    }
    if (isPrintSelected) {
      return V_PRINT;
    }
  };

  const applyFilters = (e, isLimitChanged, customParams = {}) => {
    setApplyFilters(true);
    setCustomParamsData(customParams);
    const filteredEntities = entityList.filter((i) =>
      filters.entity.includes(i.id)
    );
    setNewEntityList([]);
    setFeedObjList([]);
    setTimeout(() => {
      setNewEntityList(filteredEntities ? filteredEntities : entityList);
    }, 0);
    setEndRange(customParams.endDate);
    setStartRange(customParams.startDate);
    setTotalArticleCount(0);
    setResponseEntityWithCount(null);
    // callFeedsApi(e, isLimitChanged, customParams, false);
    // setSelectedFeeds([]);
    // setSelectedFeedsGroup([]);
  };

  const getFeedsByEntityList = () => {
    const entityIdList = newEntityList.map((entity) => entity.id);
    let apiCallCount = 1;
    const recursiveFeedsMethod = (apiCount = 1) => {
      if (apiCallCount <= FEEDS_API_RETRY_LIMIT && entityList.length > 0) {
        const timeout = 1000 * 60 * apiCount;
        setActiveKey(-1)
        fetchNewPrintFeedsByEntity({
          timeout,
          client_id: selectedClientId,
          entity: entityIdList,
          range: {
            start: startRange || customParamsData.startDate,
            end: endRange || customParamsData.endDate,
          },
          publication_type: filters.publication_type
            ? filters.publication_type
            : null,
          publication_id: getCorrectPublication(),
          edition_ids: filters && filters.edition ? filters.edition : null,
          zone: filters && filters.zone ? [filters.zone] : "",
          tonality: filters.tonality ? filters.tonality : null,
          headline: filters.headline && arrayToString(filters.headline),
          keywords: filters.keywords && arrayToString(filters.keywords),
          client: filters.client ? filters.client : null,
          category: filters.category && arrayToString(filters.category, false),
          vertical: getCorrectVertical(),
          source_type: filters.source_type ? filters.source_type : null,
          reporter: getCorrectedReporter(),
          press_release: filters.press_release ? filters.press_release : null,
          offset: 0,
          limit: MAX_FEEDS_LIMIT,
          favourite: filters.favourite ? filters.favourite : null,
          languages:selectedClientId.toString() == "11717"?filters.languages:[]
        })
          .then(async (res) => {
            const response = await res;
            setResponseEntityWithCount(response);
            // Send pageview with a custom path
            console.log("@@@@@@@@@@@@@@@@@@@@@");
            ReactGA.send({ hitType: "pageview", page: "/feedlist", title: "Client Portal : Print & Online" });
          })
          .catch((er) => {
            apiCallCount++;
            if (apiCount <= FEEDS_API_RETRY_LIMIT) {
              recursiveFeedsMethod(apiCount * 2);
              console.log(
                `retrying... count ${apiCallCount} of ${FEEDS_API_RETRY_LIMIT}`
              );
            }
          });
      }
    };
    recursiveFeedsMethod();
  };

  const callFeedsApi = (
    e,
    isLimitChanged,
    customParams = {},
    isInitialLoad
  ) => {
    const {
      zone,
      tonality,
      headline,
      keywords,
      entity,
      client,
      publication_type,
      edition,
      category,
      source_type,
      press_release,
      favourite,
    } = filters;
    dispatch(
      fetchPrintFeeds(
        {
          client_id: selectedClientId,
          entityId: entity,
          range: {
            start: customParams.startDate || startRange,
            end: customParams.endDate || endRange,
          },
          publication_type,
          publication_id: getCorrectPublication(),
          edition_ids: edition ? [edition] : null,
          zone: zone ? [zone] : "",
          tonality,
          headline: arrayToString(headline),
          keywords: arrayToString(keywords),
          entity,
          client,
          category: arrayToString(category, false),
          vertical: getCorrectVertical(),
          source_type: source_type,
          reporter: getCorrectedReporter(),
          press_release,
          offset: !isLimitChanged ? 0 : offset,
          limit: MAX_FEEDS_LIMIT,
          favourite: favourite,
        },
        isLimitChanged,
        isInitialLoad
      )
    );
    setIsFeedInit(true);
  };

  const handleSelectedFeeds = (selected, feedlist) => {
    let tempFeedsToShare = {};
    if (selected) {
      if (!Array.isArray(feedlist)) {
        tempFeedsToShare = [feedlist];
      } else {
        tempFeedsToShare = feedlist.map((elm) => {
          const {
            article_id,
            edition,
            entity_id,
            entity_name,
            entity_type,
            headline,
            imagebaseurl,
            images,
            language,
            link,
            page_nos,
            photo,
            publication,
            publication_type,
            publish_date,
            reporter_name,
            source,
            source_name,
            summary,
            article_type,
            is_client_favourite,
          } = elm;

          return {
            article_id,
            edition,
            entity_id,
            entity_name,
            entity_type,
            headline,
            imagebaseurl,
            images,
            language,
            link,
            page_nos,
            photo,
            publication,
            publication_type,
            publish_date,
            reporter_name,
            source,
            source_name,
            summary,
            article_type,
            is_client_favourite,
          };
        });
      }
      setSelectedFeeds([...selectedFeeds, ...tempFeedsToShare]);
    } else {
      if (!Array.isArray(feedlist)) {
        setSelectedFeeds(
          selectedFeeds.filter((n) => n.article_id != feedlist.article_id)
        );
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.article_id !== element.article_id) return n;
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const handleDateChange = (date, type) => {
    setFeedObjList([]);
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
    setTotalArticleCount(0);
    const formattedDate = date;
    if (type === "start") {
      setStartRange(formattedDate);
    } else {
      setEndRange(formattedDate);
    }
    setResponseEntityWithCount(null);
  };

  const renderDownloadIcon = (customParams = {}, isInlineDownload) => {
    const {
      zone,
      tonality,
      headline,
      keywords,
      entity,
      client,
      publication_type,
      edition,
      category,
      source_type,
      press_release,
      reporter,
    } = filters;

    return (
      <div className="downloadBtnWithText">
        <DownloadFeeds
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          category={category}
          client_id={selectedClientId}
          edition_id={edition}
          end_date={customParams.endDate || endRange}
          start_date={customParams.startDate || startRange}
          entities={entity}
          headline={arrayToString(headline)}
          keywords={arrayToString(keywords)}
          press_release={press_release}
          publication_id={getCorrectPublication()}
          publication_type={publication_type}
          source_type={source_type}
          reporter={reporter}
          tonality={tonality}
          zone={zone}
          client={client}
          media_type={getCorrectVertical()}
          article={selectedFeeds}
          customParams={customParams}
          isInlineDownload={isInlineDownload}
          onSuccessCallback={handleBulkUpdateSuccess}
        />
      </div>
    );
  };

  const handleFeedGroupClick = (groupIdentifier) => {
    if (selectedFeedsGroup.indexOf(groupIdentifier) !== -1) {
      setSelectedFeedsGroup(
        selectedFeedsGroup.filter((g) => g !== groupIdentifier)
      );
    } else {
      setSelectedFeedsGroup([...selectedFeedsGroup, groupIdentifier]);
    }
  };

  const handleBulkUpdateSuccess = (
    bulkUpdatedSentiment,
    bulkUpdatedTheme,
    bulkUpdatedFavourite = undefined
  ) => {
    if (
      !bulkUpdatedTheme &&
      !bulkUpdatedSentiment &&
      bulkUpdatedFavourite == undefined
    ) {
      return;
    }
    setUpdatedBulkSentiment(bulkUpdatedSentiment);
    setUpdatedBulkTheme(bulkUpdatedTheme);
    if (bulkUpdatedFavourite != undefined) {
      setUpdatedBulkFavourite(bulkUpdatedFavourite);
    }
  };

  const updateTotalArticleElement = () => {
    const articleCount =
      responseEntityWithCount &&
      Object.entries(responseEntityWithCount)
        .map((val) => val[1])
        .reduce((sum, currObj) => {
          const currentOnline = currObj.online_total ? currObj.online_total : 0;
          const currentPrint = currObj.print_total ? currObj.print_total : 0;
          sum += currentOnline + currentPrint;
          return sum;
        }, 0);
    articleCount > 0 && setTotalArticleCount(articleCount);
  };

  const filteredEntities = newEntityList.length ? newEntityList : entityList;
  const progressPopup = (open) => {
    setShowList(open);
  };
  const isDownloading =
    isPrintDownloading == "true" ||
    isSocialDownloading == "true" ||
    isBlogDownloading == "true";

  return (
    <div
      className={
        !!selectedFeeds.length
          ? "mainContainer printOnlineContainer feedsSelected"
          : "mainContainer printOnlineContainer"
      }
    >
      <div className="dashboardHeader dashboardHeading">
        <div className="dashboardHeaderTop d-flex">
          <div className="dashboardMobileMenu">
            <button className="btn menuBtn" id="menuBtn">
              <MenuIcon />
            </button>
            <img src={ConceptLogo} width="32" height="32" />
          </div>
          <div className="dhLeft d-flex">
            <div className="dhLeftWrap d-flex align-items-center">
              <h1>Print & Online</h1>
            </div>
            {popup && (
              <div className={styles.downloadLabel}>
                <DownLoadSuccess />
                <h3>Report download completed successfully !</h3>
              </div>
            )}
          </div>
        </div>
        <div className="topFilterWrap">
          <div className="mobTopHeading">
            <h1>Print & Online</h1>
          </div>
          <div className="titleRow printOnlineTitleRow">
            <div className="titleLeftWrap">
              <div className="filterWrap">
                <DateRangeFilter
                  handleDateChange={handleDateChange}
                  startRange={startRange}
                  endRange={endRange}
                  showShortCut
                  minDate={selectedClient ? selectedClient.start_date : null}
                  maxDate={selectedClient ? selectedClient.end_date : null}
                  filterTab
                  isPrintAndOnline
                />
                {renderDownloadIcon()}
                <button
                  onClick={() => toggleFilter(true)}
                  className="btn filterBtn"
                >
                  <FilterIcon /> <span>Filters</span>
                </button>
              </div>
            </div>
            <div className="rightBtnContainer">
              {!!selectedFeeds.length && (
                <button className="btn optionBtn">
                  <div className="hasTooltip">
                    <ShareArticle
                      client_id={selectedClientId}
                      article={selectedFeeds}
                    />
                    <span className="tooltipWrap center">Share</span>
                  </div>
                </button>
              )}

              {!!selectedFeeds.length && (
                <ul className="dropDownContainer">
                  <ArticleTags
                    singleNewsGroup={selectedFeeds}
                    article={selectedFeeds}
                    onSuccessCallback={handleBulkUpdateSuccess}
                    forBulkUpdate
                    setUpdatedBulkSentiment={setUpdatedBulkSentiment}
                    setUpdatedBulkTheme={setUpdatedBulkTheme}
                    setUpdatedBulkFavourite={setUpdatedBulkFavourite}
                    showFavouriteTag
                    isPrintAndOnline
                  />
                </ul>
              )}
              {renderDownloadIcon()}
              {isDownloading && !isLoading && (
                <div className={styles.DownloadPopup_downloadList__3zmI8}>
                  <DownloadPopup
                    IsPrintAndOnline={isPrintDownloading === "true"}
                    clicked={progressPopup}
                    showList={showList}
                    IsBlogAndForum={isBlogDownloading === "true"}
                    isSocial={isSocialDownloading === "true"}
                  />
                </div>
              )}
              <button
                onClick={() => toggleFilter(true)}
                className="btn filterBtn"
              >
                <FilterIcon /> <span>Filters</span>
              </button>
              <div className={showFilter ? "show" : "hide"}>
                <Filters
                  toggleFilter={toggleFilter}
                  filters={filters}
                  setFilters={setFilters}
                  applyFilters={applyFilters}
                  client_id={selectedClientId}
                  selectedVertical={getCorrectVertical()}
                  initEntityFilter={initEntityFilter}
                  handleDateChange={handleDateChange}
                  startRange={startRange}
                  endRange={endRange}
                  renderDownloadIcon={renderDownloadIcon}
                  selectedClient={selectedClient}
                  selectedTab={V_PRINT_AND_ONLINE_OLD}
                  setApplyFilters={setApplyFilters}
                  setSelectAll={setSelectAll}
                  selectedAll={selectAll}
                  handleResetFilters = {() => {
                    setSelectedFeeds([])
                    setSelectedFeedsGroup([])
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="accordion accordionListWrap printOnlineAccordion"
        ref={listContainerRef}
      >
        {entityLoader.isLoading && <GifLoader />}
        {!entityList && !entityList.length && (
          <div className="noFilterDataWrap">
            <NoFeedIcon />
            <h6>No Feeds Found</h6>
            <p>Try adjusting the filters to find what you’re looking for</p>
          </div>
        )}
        {totalArticleCount && totalArticleCount > 0 ? (
          <div
            style={{
              color: "#0036b9",
              marginTop: "5px",
              marginBottom: "5px",
              fontSize: "14px",
            }}
          >
            {startRange == endRange && (
              <>
                Total{" "}
                <span className="feed-count-info">{totalArticleCount}</span>{" "}
                articles found on{" "}
                <span className="feed-count-info">
                  {moment(startRange).format("Do MMMM YYYY")}
                </span>
              </>
            )}
            {startRange != endRange && (
              <>
                Total{" "}
                <span className="feed-count-info">{totalArticleCount}</span>{" "}
                articles were found from{" "}
                <span className="feed-count-info">
                  {moment(startRange).format("Do MMMM YYYY")}
                </span>{" "}
                to{" "}
                <span className="feed-count-info">
                  {moment(endRange).format("Do MMMM YYYY")}
                </span>
              </>
            )}
          </div>
        ) : (
          ""
        )}
        {newEntityList &&
          newEntityList.map((item, index) => {
            item["data"] = [];
            return (
              <TopicWiseNewsContainer
                listContainerRef={listContainerRef}
                key={index + 1}
                currentEntityName={item}
                listkey={index + 1}
                // entityFeeds={data}
                activeKey={activeKey}
                setActiveKey={setActiveKey}
                // allArticleList={printNewsFeeds.allArticleIdentifier}
                onFeedSelect={handleSelectedFeeds}
                selectedFeeds={selectedFeeds}
                selectedFeedsGroup={selectedFeedsGroup}
                setSelectedFeedsGroup={setSelectedFeedsGroup}
                handleFeedGroupClick={handleFeedGroupClick}
                onSuccessCallback={handleBulkUpdateSuccess}
                forBulkUpdate
                updatedBulkSentiment={updatedBulkSentiment}
                updatedBulkTheme={updatedBulkTheme}
                updatedBulkFavourite={updatedBulkFavourite}
                isPrintAndOnline
                filters={filters}
                selectedClientId={selectedClientId}
                customParams={customParamsData}
                startRange={startRange}
                endRange={endRange}
                applyFilters={appliedFilters}
                setApplyFilters={setApplyFilters}
                updateFeedObjList={(data) => {
                  setFeedObjList((prevList) => [
                    ...new Set([...prevList, JSON.stringify(data)]),
                  ]);
                }}
                responseEntityWithCount={responseEntityWithCount}
              />
            );
          })}
      </div>
    </div>
  );
}
